export class WorkerFormValues {

    // ContractorSchema {
    //     contractorId: number
    //     contractor: name
    //     schemaOptions: SelectOption[]
    //     schema: SelectOption[]
    // }

    _dni; // string
    _state; // boolean
    _name; // string
    _lastName; // string
    _job; // string
    _agreement; // string
    _contractorId; // string
    _contractorSchemas; // ContractorSchema[]

    constructor(
        dni,
        state,
        name,
        lastName,
        job,
        agreement,
        contractorId,
        contractorSchemas,
    ) {
        this._dni = dni;
        this._state = state;
        this._name = name;
        this._lastName = lastName;
        this._job = job;
        this._agreement = agreement;
        this._contractorId = contractorId;
        this._contractorSchemas = contractorSchemas;
    }

    static null() {
        return new this(
            '',
            false,
            '',
            '',
            '',
            '',
            -1,
            [],
        );
    }

    static fromCurrentUser(user) {
        return new this(
            '',
            false,
            '',
            '',
            '',
            '',
            user.contractorId(),
            [],
        );
    }

    static fromWorker(worker) {
        const contractorSchemas = worker
            .documentation()
            .schemas()
            .map((association) => {
                const contractor = association.contractor();
                const documentSchema = association.documentSchema();

                return {
                    contractorId: contractor.id(),
                    contractor: contractor.description(),
                    schemaOptions: [], // completados en ResourceContractorSchemas
                    schema: [{
                        label: documentSchema.description(),
                        value: documentSchema.id(),
                        disabled: false,
                        item: documentSchema,
                    }],
                    position: association._position,
                };
            });

        return new this(
            worker.dni(),
            worker.isActive(),
            worker.name(),
            worker.lastName(),
            worker.job(),
            worker.agreement(),
            worker.contractorId(),
            contractorSchemas,
        );
    }

    initialValues() {
        return {
            dni: this._dni,
            state: this._state,
            name: this._name,
            lastName: this._lastName,
            job: this._job,
            agreement: this._agreement,
            contractorId: this._contractorId,
            contractorSchemas: this._contractorSchemas,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/WorkerFormValues.js